import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NotificationService, GridDataSource, LoaderService, ErrorService, UtilityService } from "../../../../shared/session/index";
import { AplicacionService } from "../../Aplicaciones/shared/aplicacion.service"
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { Iempresa, Empresa } from '../shared/empresa.model';
import { EmpresaService } from '../shared/empresa.service';

@Component({
    selector: 'app-empresa-view',
    templateUrl: 'empresa-view.component.html'
})
export class EmrpesaViewComponent implements OnInit {

    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @Output() onEmitParam: EventEmitter<any> = new EventEmitter();
    @Input() data: any;
    @Input() titlePage: string;

    pageEvent: PageEvent;
    empresa: Iempresa;
    msgErrorGet: string;
    indObteneroffice: boolean;
    dataSource: GridDataSource;

    constructor(private notificationService: NotificationService, private empresaService: EmpresaService,
        private utilityService: UtilityService, private loaderService: LoaderService) { }

    ngOnInit() {

        this.empresa = new Empresa(0, "", "", "", "", "", "", true, "", "", "", "", "", null, "");
        this.msgErrorGet = 'Error al obtener datos';
        this.obtenerEmpresa(this.data.empresa.ID);

    }

    private obtenerEmpresa(ID: number): void {
        this.loaderService.show();
        this.empresaService.obtenerEmpresa(ID)
            .subscribe(res => {
                this.empresa = res;
            },
                error => {
                    this.notificationService.error(this.msgErrorGet);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }
}
